import { useKeycloak } from "@react-keycloak/web";
import { Avatar, Dropdown } from "antd";
import { Link } from "react-router-dom";
import { useAppSelector } from "../../../app/store";
import HomeIcon from "../../../assets/icons/HomeIcon";
import LogoutIcon from "../../../assets/icons/LogoutIcon";
import SettingIcon from "../../../assets/icons/SettingIcon";
import UserSettingIcon from "../../../assets/icons/UserSettingIcon";
import PLACEHOLDER_IMG from "../../../assets/images/avatar.svg";
import { removeSession } from "../../../utils/remove";

export default function ProfileMenu() {
  // const dispatch = useAppDispatch();
  const { keycloak } = useKeycloak();
  const { role, user } = useAppSelector((state) => state.auth);

  return (
    <Dropdown
      placement="bottomRight"
      arrow={{ pointAtCenter: true }}
      className="cursor-pointer"
      rootClassName="!left-auto !right-5"
      dropdownRender={() => (
        <ul className="list-none bg-white shadow p-1 rounded">
          <li>
            <Link
              to="/admin/dashboard"
              className="flex items-center mb-2 gap-3 py-2 px-8 cursor-pointer select-none text-body hover:text-primary hover:bg-[#FFF5F4] text-sm rounded"
            >
              <HomeIcon /> <span>Sheba Portal</span>
            </Link>
          </li>

          {role === "SUPER_ADMIN" && (
            <li>
              <Link
                to="/admin/businesses/business-list"
                className="flex items-center mb-2 gap-3 py-2 px-8 cursor-pointer select-none text-body hover:text-primary hover:bg-[#FFF5F4] text-sm rounded"
              >
                <UserSettingIcon /> <span>Administration</span>
              </Link>
            </li>
          )}

          {(role === "Admin" || role === "HR_ADMIN") && (
            <li>
              <Link
                to="/admin/employees"
                // to="/admin/users-roll-access/user-list"
                // onClick={() => localStorage.clear()}
                onClick={() => {
                  localStorage.removeItem("project_role");
                  localStorage.removeItem("product_id");
                  localStorage.removeItem("product_logo");
                  localStorage.removeItem("product_name");
                  localStorage.removeItem("BSRM_USER");
                  localStorage.removeItem("product-type");
                  localStorage.removeItem("batch-segment");
                }}
                className="flex items-center mb-2 gap-3 py-2 px-8 cursor-pointer select-none text-body hover:text-primary hover:bg-[#FFF5F4] text-sm rounded"
              >
                <UserSettingIcon /> <span>Administration</span>
              </Link>
            </li>
          )}

          <li>
            <Link
              to="/admin/user-info"
              // onClick={() => localStorage.clear()}
              onClick={() => {
                localStorage.removeItem("project_role");
                localStorage.removeItem("product_id");
                localStorage.removeItem("product_logo");
                localStorage.removeItem("product_name");
                localStorage.removeItem("BSRM_USER");
                localStorage.removeItem("product-type");
                localStorage.removeItem("batch-segment");
              }}
              className="flex items-center mb-2 gap-3 py-2 px-8 cursor-pointer select-none text-body hover:text-primary hover:bg-[#FFF5F4] text-sm rounded"
            >
              <SettingIcon /> <span>My Profile</span>
            </Link>
          </li>
          <li
            // onClick={() => {
            //   dispatch(userLoggedOut());
            // }}
            onClick={() => {
              keycloak.logout();
              removeSession();
            }}
            className="flex items-center gap-3 py-2 px-8 cursor-pointer select-none text-body hover:text-primary hover:bg-[#FFF5F4] text-sm rounded"
          >
            <LogoutIcon /> <span className="text-[#FF3838]">Logout</span>
          </li>
        </ul>
      )}
    >
      <div className="flex items-center gap-2.5 cursor-pointer">
        <Avatar size={44} src={user?.data?.photo || PLACEHOLDER_IMG} />
        {/* <span className="text-[#555b6d] text-base font-medium flex items-center">
          {login?.firstName} <BottomDropdownIcon />
        </span> */}
      </div>
    </Dropdown>
  );
}
